import {EntityModel} from "@fedeltapointofsale/data-client";
import {FunctionBarData} from "./function-bar.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class FunctionBarEntityModel extends EntityModel<FunctionBarData> {
    constructor(injector: Injector) {
            super(injector, FunctionBarData);
    }

    override canCreateEntity(): Promise<boolean> {
        return Promise.resolve(false);
    }
}
